module.exports = __webpack_public_path__ + "img/p7-p1-molihua.75bdddf0.png";